import { SchemaWithClient } from '../types/SchemaWithClient';
import { Client } from '../services/Client';
import { NumberField } from '../components/Table/fields/NumberField';
import { TextField } from '../components/Table/fields/TextField';
import { RoomType } from '../types/entities/RoomType';
import { SPTextField } from '../components/Table/fields/SPTextField';
import { SPNumberField } from '../components/Table/fields/SPNumberField';

export const roomType: SchemaWithClient<RoomType> = {
  name: 'Room Type',
  pluralName: 'Room Type',
  columns: {
    name: {
      name: 'Name',
      required: true,
      fieldRenderer: TextField,
      slidePaneFieldRenderer: SPTextField,
      fieldType: 'text',
    },
    size: {
      name: 'Size',
      fieldRenderer: NumberField,
      slidePaneFieldRenderer: SPNumberField,
      fieldType: 'number',
    },
    id: {
      name: 'ID',
      required: true,
      fieldRenderer: NumberField,
      slidePaneFieldRenderer: SPNumberField,
      fieldType: 'number',
      readOnly: true,
    },
  },
  client: new Client('/enums/room-types'),
};
